/**
 * Owner: Muhammad Awd
 * POSTMAN DOCUMENTATION : none
 * SWAGGER DOCUMENTATION : none
 */
export default {
    // base services

    URL_BASE: process.env.VUE_APP_API_BASE,

    // auth base api routes
    COMMON_CONFIG: '/config/env',
    COMMON_LOOKUPS: '/lookups/departments',
    COMMON_COUNTRIES: '/lookups/country-codes',
    COMMON_UPLOAD_IMAGE: '/attachments',
    REFRESH_ACCESS_TOKEN: '',
    AUTH_JWT_LOGIN: '/user/login', // PUT
    AUTH_JWT_REGISTER: '/user', // POST
    AUTH_JWT_HAS_PASSWORD: '/user/check-has-password', // POST
    AUTH_JWT_FORGET_PASSWORD: '/user/send-reset-password-email', // POST
    AUTH_JWT_RESET_PASSWORD: '/user/reset-password', // PUT
    AUTH_JWT_SEND_VERIFY: '/user/send-otp-mobile', // POST
    AUTH_JWT_SEND_VERIFY_EMAIL: '/user/send-otp-email', // POST
    AUTH_JWT_ACTIVE_VERIFY: '/user/verify-otp', // PUT
    AUTH_JWT_VERIFY: '/user', // GET
    AUTH_JWT_UPDATE_USER: '/user', // PUT
    AUTH_JWT_VERIFY_USER: '/user/verify-user', // PUT
    AUTH_JWT_RESEND_VERIFY_USER: '/user/verification-code/resend', // PUT


    ALL_PROGRAMS: '/mobile/program/active-and-published', // GET
    FIND_PROGRAM: '/mobile/program/:id', // GET
    FIND_JSON_FORM: '/mobile/form-json/:id', // GET
    SUBMIT_PROGRAM: '/mobile/user/form-data', // POST

    LIST_USER_PROGRAMS: '/mobile/program/my-programs', // GET
    LIST_USER_PROGRAM_RESULTS: '/mobile/user/exam-details', // GET
    GET_SUBMITTED_FORM: '/mobile/user/form-data/:id', // GET
    RESUBMITTED_FORM: '/mobile/user/form-data', // POST

    GET_EVENTS: '/mobile/events', // GET
    FIND_EVENT: '/mobile/events/:id', // GET,
    GET_NEWS: '/mobile/news', // GET
    FIND_NEWS: '/mobile/news/:id', // GET
};
